import { render, staticRenderFns } from "./EditCustomerBabyName.vue?vue&type=template&id=95d004ba&scoped=true&"
import script from "./EditCustomerBabyName.vue?vue&type=script&lang=js&"
export * from "./EditCustomerBabyName.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerBabyName.vue?vue&type=style&index=0&id=95d004ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d004ba",
  null
  
)

export default component.exports